import type { Story } from '@/store/story-types'

export const MEMBERSHIP_CLUB_STORY: Story = {
  id: 'membership-club',
  name: 'INNER CIRCLE — Alex\'s Fan Club',
  narrative: 'An influencer fan club with tiered memberships that unlocks exclusive content, behind-the-scenes access, and special perks for subscribers.',
  goals: ['Introduce the creator', 'Present membership tiers', 'Showcase exclusive content', 'Enable membership purchase'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home',
      title: 'Home',
      order: 0,
      status: 'draft',
      elementCount: 5,
      linkedPageId: 'home',
      description: 'Club landing with hero, membership tiers, and exclusive content preview',
      blockRef: { category: 'membership', blockId: 'club-hero' },
    },
    {
      id: 'pg-cart',
      title: 'Cart',
      order: 1,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'cart',
      description: 'Cart with selected membership plan',
      blockRef: { category: 'commerce', blockId: 'cart-view' },
    },
    {
      id: 'pg-checkout',
      title: 'Checkout',
      order: 2,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'checkout',
      description: 'Checkout form for membership subscription payment',
      blockRef: { category: 'commerce', blockId: 'checkout' },
    },
    {
      id: 'pg-welcome',
      title: 'Welcome',
      order: 3,
      status: 'draft',
      elementCount: 3,
      linkedPageId: 'order-confirmation',
      description: 'Welcome page confirming membership activation',
      blockRef: { category: 'membership', blockId: 'order-confirmation' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'View Club Landing',
      description: 'Visitor discovers the fan club homepage',
      steps: [
        { type: 'given', text: 'the visitor is on the homepage' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the club hero, creator introduction, and membership tiers are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Browse Exclusive Content',
      description: 'Visitor previews exclusive content available to members',
      steps: [
        { type: 'given', text: 'the visitor is on the homepage' },
        { type: 'when', text: 'they scroll to the exclusive content section' },
        { type: 'then', text: 'locked content previews with tier badges are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Select Membership Tier',
      description: 'Visitor selects a membership plan to join',
      steps: [
        { type: 'given', text: 'the visitor is viewing membership tiers' },
        { type: 'when', text: 'they tap Join on a tier' },
        { type: 'then', text: 'the selected plan is added to the cart', linkedPageId: 'home', linkedFlowId: 'selectTier' },
        { type: 'and', text: 'the visitor is navigated to the cart page', linkedPageId: 'cart' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Complete Membership Purchase',
      description: 'Visitor completes the membership subscription',
      steps: [
        { type: 'given', text: 'the visitor has a membership plan in the cart' },
        { type: 'when', text: 'they proceed to checkout and fill in payment details', linkedPageId: 'checkout' },
        { type: 'then', text: 'the subscription is activated and a welcome page is shown', linkedPageId: 'order-confirmation', linkedFlowId: 'placeOrder' },
      ],
    },
    {
      id: 'bdd-5',
      name: 'Access Member Benefits',
      description: 'New member accesses unlocked content',
      steps: [
        { type: 'given', text: 'the visitor has completed membership purchase' },
        { type: 'when', text: 'they return to the homepage' },
        { type: 'then', text: 'previously locked content is now accessible', linkedPageId: 'home' },
      ],
    },
  ],
}
